import environment from "@/modules/environment";

const { appName } = environment;

export function getAppValue<T>(value: { bibino?: T; barkio?: T; camerito?: T; fallback?: T }) {
  return (value[appName] || value.fallback) as T;
}
